import { render } from "./Price.vue?vue&type=template&id=27ab9f2c&scoped=true&ts=true"
import script from "./Price.vue?vue&type=script&lang=ts"
export * from "./Price.vue?vue&type=script&lang=ts"

import "./Price.vue?vue&type=style&index=0&id=27ab9f2c&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ab9f2c"]])

export default __exports__